<section class="banner">
    <app-nav class="w-100"></app-nav>
    <div class="container-fluid mob-px-5 v4-adjustment">
        <div class="d-flex justify-content-between pt-5">
            <div class="d-flex">
                <img class="img-icon" src="../../../../../assets/v-4-icone/history.png" alt="loading" />
                <h2 class="font-600 v4-color-white">
                    {{ "New Branch Training" | translator }}
                </h2>
            </div>
        </div>
        <div class="d-flex justify-content-between align-items-center flex-wrap my-3 mx-3 w-100">
            <div class="d-flex flex-wrap">
                <span class="d-flex align-items-center">
                    <span class="custom-bredcrum-btn d-flex align-items-center">
                        home page
                    </span>
                    <span class=""><i class="pi pi-fw pi-angle-left"></i></span>
                </span>
                <span class="d-flex align-items-center">
                    <span class="custom-bredcrum-btn font-600 d-flex align-items-center">
                        {{ "New Branch Training" | translator }}
                    </span>
                </span>
            </div>
            <div class="d-flex flex-wrap">
                <ng-container>
                    <div class="align-items-center d-flex flex-wrap">
                        <a class="create-training-btn m-2 align-items-center d-flex"><i
                                class="pi pi-plus-circle mx-2"></i>{{ "Add Training Program" | translator }}</a>

                        <a class="create-training-btn m-2 align-items-center d-flex"><i
                                class="pi pi-plus-circle mx-2"></i>{{ "Create a request" | translator }}</a>

                        <a class="create-training-btn m-2 align-items-center d-flex"><i
                                class="pi pi-chart-bar mx-2"></i>{{ "Show Dashboard" | translator }}</a>

                        <a class="create-training-btn m-2 align-items-center d-flex"><i class="pi pi-list mx-2"></i>{{
                            "Show List" | translator }}</a>

                        <a class="create-training-btn m-2 align-items-center d-flex"><i
                                class="pi pi-calendar mx-2"></i>{{ "Show Calender" | translator }}</a>
                    </div>
                </ng-container>

                <ng-container>
                    <a class="create-training-btn m-2 align-items-center d-flex"><i
                            class="pi pi-times-circle mx-2"></i>{{ "close" | translator }}</a>
                </ng-container>
            </div>
        </div>
    </div>
</section>
<div class="white-box container-fluid mb-5 v4-px-3">
    <div>
        <div class="grey-box">
            <div class="dynamic-table-main-tr">
                <!-- Header -->
                <div class="row f-table">
                    <div class="col-md-1 col-12">
                        <div class="v4-bold">#</div>
                    </div>
                    <div class="col-md-3 col-12">
                        <div class="v4-bold">List of Participents</div>
                    </div>
                    <div class="col-md-2 col-12">
                        <div class="v4-bold">Date</div>
                    </div>
                    <div class="col-md-2 col-12">
                        <div class="v4-bold">Time</div>
                    </div>
                    <div class="col-md-2 col-12">
                        <div class="v4-bold">Action</div>
                    </div>
                    <div class="col-md-2 col-12">
                        <div class="v4-bold">Action</div>
                    </div>
                </div>
                <!-- End Header -->
                <ng-container>
                    <!-- Training  -->
                    <ng-container>
                        <div class="row px-2 mob-my-4">
                            <div class="col-md-1 col-12 p-0 3333">
                                <div class="tabel-detail-box adjustment">
                                    <div class="d-flex">
                                        <div class="ms-tabel-num-box" (click)="op.toggle($event)">
                                            <i class="pi pi-folder-open f-2rem"></i>
                                        </div>
                                    </div>
                                    <div class="d-flex bold">1</div>
                                </div>
                            </div>

                            <div class="col-md-3 col-12 p-0">
                                <div class="tabel-detail-box">
                                    <div class="tab-scroll">Title-R</div>
                                </div>
                            </div>

                            <div class="col-md-2 col-12 p-0">
                                <div class="tabel-detail-box">
                                    <div dir="ltr" class="w-100">
                                        <p-calendar class="v4-calander v4-timer w-100" [dateFormat]="'dd MM yy'"
                                            [showIcon]="true" [showButtonBar]="true"
                                            [inputStyle]="{ 'text-align': 'right' }">
                                        </p-calendar>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-2 col-12 p-0">
                                <div class="tabel-detail-box">
                                    <div class="d-flex w-100">
                                        <div class="flex-auto w-100">
                                            <p-calendar class="v4-timer" inputId="calendar-timeonly"
                                                [inputStyle]="{ 'text-align': 'right' }" [placeholder]="'time'"
                                                [timeOnly]="true" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-2 col-12 p-0">
                                <div class="tabel-detail-box">
                                    <div class="d-flex align-items-center w-100">
                                        <input type="text" class="radius-8 v4-timer" style="width: 100%" pInputText
                                            placeholder="links" />
                                    </div>
                                </div>
                            </div>

                            <div #targetEl class="col-md-2 col-12 p-0">
                                <div class="tabel-detail-box">
                                    <div class="tab-scroll d-flex flex-wrap align-items-center">
                                        <a pTooltip="{{ 'amendment' | translator }}" tooltipPosition="top"
                                            class="invite-btn">Invite Button</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <p-overlayPanel class="v4-p-overlay-panel" [style]="{ width: '500px' }" #op>
                            <app-training-timeline [isToolTip]="true"></app-training-timeline>
                        </p-overlayPanel>
                    </ng-container>
                    <!-- End Training  -->

                    <!-- Training Program -->
                    <ng-container>
                        <div class="folder-open">
                            <div class="">
                                <div class="row p-0">
                                    <div class="col-md-1 col-12 p-0 1111">
                                        <div class="tabel-detail-box adjustment">
                                            <div class="d-flex">
                                                <div data-label="#" class="ms-tabel-num-box">
                                                    <i class="fa fa-solid fa-chalkboard-user f-2rem-user"></i>
                                                </div>
                                            </div>
                                            <div class="d-flex bold">1</div>
                                        </div>
                                    </div>
                                    <div class="col-md-3 col-12 p-0">
                                        <div class="tabel-detail-box">
                                            <div data-label="la wasuf" class="tab-scroll">title</div>
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-12 p-0">
                                        <div class="tabel-detail-box">
                                            <div class="tab-scroll d-flex flex-wrap align-items-center">
                                                <a pTooltip="{{ 'amendment' | translator }}" tooltipPosition="top"
                                                    class="invite-btn">Invite Button</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-12 p-0">
                                        <div class="tabel-detail-box">
                                            <div
                                                class="tab-scroll d-flex justify-content-center flex-wrap align-items-center">
                                                <p-checkbox name="groupname" value="val1"></p-checkbox>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="">
                                <div class="row p-0">
                                    <div class="col-md-1 col-12 p-0 4444">
                                        <div class="tabel-detail-box adjustment">
                                            <div class="d-flex">
                                                <div data-label="#" class="ms-tabel-num-box">
                                                    <i class="fa fa-solid fa-chalkboard-user f-2rem-user"></i>
                                                </div>
                                            </div>
                                            <div class="d-flex bold">1</div>
                                        </div>
                                    </div>
                                    <div class="col-md-3 col-12 p-0">
                                        <div class="tabel-detail-box">
                                            <div data-label="la wasuf" class="tab-scroll">title</div>
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-12 p-0">
                                        <div class="tabel-detail-box">
                                            <div class="tab-scroll d-flex flex-wrap align-items-center">
                                                <a pTooltip="{{ 'amendment' | translator }}" tooltipPosition="top"
                                                    class="invite-btn">Invite Button</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-12 p-0">
                                        <div class="tabel-detail-box">
                                            <div
                                                class="tab-scroll d-flex justify-content-center flex-wrap align-items-center">
                                                <p-checkbox name="groupname" value="val1"></p-checkbox>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="">
                                <div class="row p-0">
                                    <div class="col-md-1 col-12 p-0 1111">
                                        <div class="tabel-detail-box adjustment">
                                            <div class="d-flex">
                                                <div data-label="#" class="ms-tabel-num-box">
                                                    <i class="fa fa-solid fa-chalkboard-user f-2rem-user"></i>
                                                </div>
                                            </div>
                                            <div class="d-flex bold">1</div>
                                        </div>
                                    </div>
                                    <div class="col-md-3 col-12 p-0">
                                        <div class="tabel-detail-box">
                                            <div data-label="la wasuf" class="tab-scroll">title</div>
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-12 p-0">
                                        <div class="tabel-detail-box">
                                            <div class="tab-scroll d-flex flex-wrap align-items-center">
                                                <a pTooltip="{{ 'amendment' | translator }}" tooltipPosition="top"
                                                    class="invite-btn">Invite Button</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-12 p-0">
                                        <div class="tabel-detail-box">
                                            <div
                                                class="tab-scroll d-flex justify-content-center flex-wrap align-items-center">
                                                <p-checkbox name="groupname" value="val1"></p-checkbox>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- extra single section end -->
                        </div>
                    </ng-container>
                    <!-- End Training Program -->
                    <ng-container>
                        <div class="row px-2 mob-my-4">
                            <div class="col-md-1 col-12 p-0 4444">
                                <div class="tabel-detail-box adjustment">
                                    <div class="d-flex">
                                        <div class="ms-tabel-num-box" (click)="op.toggle($event)">
                                            <i class="pi pi-folder-open f-2rem"></i>
                                        </div>
                                    </div>
                                    <div class="d-flex bold">1</div>
                                </div>
                            </div>

                            <div class="col-md-3 col-12 p-0">
                                <div class="tabel-detail-box">
                                    <div class="tab-scroll">Title-R</div>
                                </div>
                            </div>

                            <div class="col-md-2 col-12 p-0">
                                <div class="tabel-detail-box">
                                    <div dir="ltr" class="w-100">
                                        <p-calendar class="v4-calander v4-timer w-100" [dateFormat]="'dd MM yy'"
                                            [showIcon]="true" [showButtonBar]="true"
                                            [inputStyle]="{ 'text-align': 'right' }">
                                        </p-calendar>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-2 col-12 p-0">
                                <div class="tabel-detail-box">
                                    <div class="d-flex w-100">
                                        <div class="flex-auto w-100">
                                            <p-calendar class="v4-timer" inputId="calendar-timeonly"
                                                [inputStyle]="{ 'text-align': 'right' }" [placeholder]="'time'"
                                                [timeOnly]="true" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-2 col-12 p-0">
                                <div class="tabel-detail-box">
                                    <div class="d-flex align-items-center w-100">
                                        <input type="text" class="radius-8 v4-timer" style="width: 100%" pInputText
                                            placeholder="links" />
                                    </div>
                                </div>
                            </div>

                            <div #targetEl class="col-md-2 col-12 p-0">
                                <div class="tabel-detail-box">
                                    <div class="tab-scroll d-flex flex-wrap align-items-center">
                                        <a pTooltip="{{ 'amendment' | translator }}" tooltipPosition="top"
                                            class="invite-btn">Invite Button</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row px-2 mob-my-4">
                            <div class="col-md-1 col-12 p-0 4444">
                                <div class="tabel-detail-box adjustment">
                                    <div class="d-flex">
                                        <div class="ms-tabel-num-box" (click)="op.toggle($event)">
                                            <i class="pi pi-folder-open f-2rem"></i>
                                        </div>
                                    </div>
                                    <div class="d-flex bold">1</div>
                                </div>
                            </div>

                            <div class="col-md-3 col-12 p-0">
                                <div class="tabel-detail-box">
                                    <div class="tab-scroll">Title-R</div>
                                </div>
                            </div>

                            <div class="col-md-2 col-12 p-0">
                                <div class="tabel-detail-box">
                                    <div dir="ltr" class="w-100">
                                        <p-calendar class="v4-calander v4-timer w-100" [dateFormat]="'dd MM yy'"
                                            [showIcon]="true" [showButtonBar]="true"
                                            [inputStyle]="{ 'text-align': 'right' }">
                                        </p-calendar>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-2 col-12 p-0">
                                <div class="tabel-detail-box">
                                    <div class="d-flex w-100">
                                        <div class="flex-auto w-100">
                                            <p-calendar class="v4-timer" inputId="calendar-timeonly"
                                                [inputStyle]="{ 'text-align': 'right' }" [placeholder]="'time'"
                                                [timeOnly]="true" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-2 col-12 p-0">
                                <div class="tabel-detail-box">
                                    <div class="d-flex align-items-center w-100">
                                        <input type="text" class="radius-8 v4-timer" style="width: 100%" pInputText
                                            placeholder="links" />
                                    </div>
                                </div>
                            </div>

                            <div #targetEl class="col-md-2 col-12 p-0">
                                <div class="tabel-detail-box">
                                    <div class="tab-scroll d-flex flex-wrap align-items-center">
                                        <a pTooltip="{{ 'amendment' | translator }}" tooltipPosition="top"
                                            class="invite-btn">Invite Button</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row px-2 mob-my-4">
                            <div class="col-md-1 col-12 p-0 4444">
                                <div class="tabel-detail-box adjustment">
                                    <div class="d-flex">
                                        <div class="ms-tabel-num-box" (click)="op.toggle($event)">
                                            <i class="pi pi-folder-open f-2rem"></i>
                                        </div>
                                    </div>
                                    <div class="d-flex bold">1</div>
                                </div>
                            </div>

                            <div class="col-md-3 col-12 p-0">
                                <div class="tabel-detail-box">
                                    <div class="tab-scroll">Title-R</div>
                                </div>
                            </div>

                            <div class="col-md-2 col-12 p-0">
                                <div class="tabel-detail-box">
                                    <div dir="ltr" class="w-100">
                                        <p-calendar class="v4-calander v4-timer w-100" [dateFormat]="'dd MM yy'"
                                            [showIcon]="true" [showButtonBar]="true"
                                            [inputStyle]="{ 'text-align': 'right' }">
                                        </p-calendar>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-2 col-12 p-0">
                                <div class="tabel-detail-box">
                                    <div class="d-flex w-100">
                                        <div class="flex-auto w-100">
                                            <p-calendar class="v4-timer" inputId="calendar-timeonly"
                                                [inputStyle]="{ 'text-align': 'right' }" [placeholder]="'time'"
                                                [timeOnly]="true" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-2 col-12 p-0">
                                <div class="tabel-detail-box">
                                    <div class="d-flex align-items-center w-100">
                                        <input type="text" class="radius-8 v4-timer" style="width: 100%" pInputText
                                            placeholder="links" />
                                    </div>
                                </div>
                            </div>

                            <div #targetEl class="col-md-2 col-12 p-0">
                                <div class="tabel-detail-box">
                                    <div class="tab-scroll d-flex flex-wrap align-items-center">
                                        <a pTooltip="{{ 'amendment' | translator }}" tooltipPosition="top"
                                            class="invite-btn">Invite Button</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
            </div>
        </div>
        <div class="flex justify-content-center">
            <p-paginator [rowsPerPageOptions]="[10, 20, 30]"></p-paginator>
        </div>
    </div>
</div>
<app-footer></app-footer>

<section class="banner">
    <app-nav class="w-100"></app-nav>
    <div class="container-fluid mob-px-5 v4-adjustment">
        <div class="d-flex justify-content-between pt-5">
            <div class="d-flex">
                <img class="img-icon" src="../../../../../assets/v-4-icone/history.png" alt="loading" />
                <h2 class="font-600 v4-color-white">
                    {{ "New Branch Training" | translator }}
                </h2>
            </div>
        </div>
        <div class="d-flex justify-content-between align-items-center flex-wrap my-3 mx-3 w-100">
            <div class="d-flex flex-wrap">
                <span class="d-flex align-items-center">
                    <span class="custom-bredcrum-btn d-flex align-items-center">
                        home page
                    </span>
                    <span class=""><i class="pi pi-fw pi-angle-left"></i></span>
                </span>
                <span class="d-flex align-items-center">
                    <span class="custom-bredcrum-btn font-600 d-flex align-items-center">
                        {{ "New Branch Training" | translator }}
                    </span>
                </span>
            </div>
            <div class="d-flex flex-wrap">
                <ng-container>
                    <div class="align-items-center d-flex flex-wrap">
                        <a class="create-training-btn m-2 align-items-center d-flex"><i
                                class="pi pi-plus-circle mx-2"></i>{{ "Add Training Program" | translator }}</a>

                        <a class="create-training-btn m-2 align-items-center d-flex"><i
                                class="pi pi-plus-circle mx-2"></i>{{ "Create a request" | translator }}</a>

                        <a class="create-training-btn m-2 align-items-center d-flex"><i
                                class="pi pi-chart-bar mx-2"></i>{{ "Show Dashboard" | translator }}</a>

                        <a class="create-training-btn m-2 align-items-center d-flex"><i class="pi pi-list mx-2"></i>{{
                            "Show List" | translator }}</a>

                        <a class="create-training-btn m-2 align-items-center d-flex"><i
                                class="pi pi-calendar mx-2"></i>{{ "Show Calender" | translator }}</a>
                    </div>
                </ng-container>

                <ng-container>
                    <a class="create-training-btn m-2 align-items-center d-flex"><i
                            class="pi pi-times-circle mx-2"></i>{{ "close" | translator }}</a>
                </ng-container>
            </div>
        </div>
    </div>
</section>
<div class="white-box container-fluid mb-5 v4-px-3">
    <div>
        <div class="grey-box">
            <div class="dynamic-table-main-tr">
                <!-- Header -->
                <div class="row f-table">
                    <div class="col-md-1 col-12">
                        <div class="v4-bold">#</div>
                    </div>
                    <div class="col-md-3 col-12">
                        <div class="v4-bold">List of Participents</div>
                    </div>
                    <div class="col-md-6 col-12">
                        <div class="v4-bold">Date</div>
                    </div>
                    <div class="col-md-2 col-12">
                        <div class="v4-bold">Time</div>
                    </div>
                </div>
                <!-- End Header -->
                <ng-container>
                    <!-- Training  -->
                    <ng-container>
                        <div class="row px-2 mob-my-4">
                            <div class="col-md-1 col-12 p-0 3333">
                                <div class="tabel-detail-box adjustment">
                                    <div class="d-flex">
                                        <div class="ms-tabel-num-box" (click)="op.toggle($event)">
                                            <i class="pi pi-folder-open f-2rem"></i>
                                        </div>
                                    </div>
                                    <div class="d-flex bold">1</div>
                                </div>
                            </div>

                            <div class="col-md-3 col-12 p-0">
                                <div class="tabel-detail-box">
                                    <div class="tab-scroll">Title-R</div>
                                </div>
                            </div>

                            <div class="col-md-6 col-12 p-0">
                                <div class="tabel-detail-box">
                                    <div dir="ltr" class="w-100">
                                        <p-dropdown class="v4-drop" appendTo="body"></p-dropdown>
                                    </div>
                                </div>
                            </div>

                            <div #targetEl class="col-md-2 col-12 p-0">
                                <div class="tabel-detail-box">
                                    <div class="tab-scroll d-flex flex-wrap align-items-center">
                                        <a pTooltip="{{ 'amendment' | translator }}" tooltipPosition="top"
                                            class="invite-btn">Invite Button</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <p-overlayPanel class="v4-p-overlay-panel" [style]="{ width: '500px' }" #op>
                            <app-training-timeline [isToolTip]="true"></app-training-timeline>
                        </p-overlayPanel>
                    </ng-container>
                    <!-- End Training  -->

                    <!-- Training Program -->
                    <ng-container>
                        <div class="folder-open">
                            <div class="">
                                <div class="row p-0">
                                    <div class="col-md-1 col-12 p-0 1111">
                                        <div class="tabel-detail-box adjustment">
                                            <div class="d-flex">
                                                <div data-label="#" class="ms-tabel-num-box">
                                                    <i class="fa fa-solid fa-chalkboard-user f-2rem-user"></i>
                                                </div>
                                            </div>
                                            <div class="d-flex bold">1</div>
                                        </div>
                                    </div>
                                    <div class="col-md-3 col-12 p-0">
                                        <div class="tabel-detail-box">
                                            <div data-label="la wasuf" class="tab-scroll">title</div>
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-12 p-0">
                                        <div class="tabel-detail-box">
                                            <div class="tab-scroll d-flex flex-wrap align-items-center">
                                                <a pTooltip="{{ 'amendment' | translator }}" tooltipPosition="top"
                                                    class="invite-btn">Invite Button</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-12 p-0">
                                        <div class="tabel-detail-box">
                                            <div
                                                class="tab-scroll d-flex justify-content-center flex-wrap align-items-center">
                                                <p-checkbox name="groupname" value="val1"></p-checkbox>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="">
                                <div class="row p-0">
                                    <div class="col-md-1 col-12 p-0 4444">
                                        <div class="tabel-detail-box adjustment">
                                            <div class="d-flex">
                                                <div data-label="#" class="ms-tabel-num-box">
                                                    <i class="fa fa-solid fa-chalkboard-user f-2rem-user"></i>
                                                </div>
                                            </div>
                                            <div class="d-flex bold">1</div>
                                        </div>
                                    </div>
                                    <div class="col-md-3 col-12 p-0">
                                        <div class="tabel-detail-box">
                                            <div data-label="la wasuf" class="tab-scroll">title</div>
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-12 p-0">
                                        <div class="tabel-detail-box">
                                            <div class="tab-scroll d-flex flex-wrap align-items-center">
                                                <a pTooltip="{{ 'amendment' | translator }}" tooltipPosition="top"
                                                    class="invite-btn">Invite Button</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-12 p-0">
                                        <div class="tabel-detail-box">
                                            <div
                                                class="tab-scroll d-flex justify-content-center flex-wrap align-items-center">
                                                <p-checkbox name="groupname" value="val1"></p-checkbox>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="">
                                <div class="row p-0">
                                    <div class="col-md-1 col-12 p-0 1111">
                                        <div class="tabel-detail-box adjustment">
                                            <div class="d-flex">
                                                <div data-label="#" class="ms-tabel-num-box">
                                                    <i class="fa fa-solid fa-chalkboard-user f-2rem-user"></i>
                                                </div>
                                            </div>
                                            <div class="d-flex bold">1</div>
                                        </div>
                                    </div>
                                    <div class="col-md-3 col-12 p-0">
                                        <div class="tabel-detail-box">
                                            <div data-label="la wasuf" class="tab-scroll">title</div>
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-12 p-0">
                                        <div class="tabel-detail-box">
                                            <div class="tab-scroll d-flex flex-wrap align-items-center">
                                                <a pTooltip="{{ 'amendment' | translator }}" tooltipPosition="top"
                                                    class="invite-btn">Invite Button</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-12 p-0">
                                        <div class="tabel-detail-box">
                                            <div
                                                class="tab-scroll d-flex justify-content-center flex-wrap align-items-center">
                                                <p-checkbox name="groupname" value="val1"></p-checkbox>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- extra single section end -->
                        </div>
                    </ng-container>
                    <!-- End Training Program -->
                </ng-container>
            </div>
        </div>
        <div class="flex justify-content-center">
            <p-paginator [rowsPerPageOptions]="[10, 20, 30]"></p-paginator>
        </div>
    </div>
</div>
<app-footer></app-footer>